import Layout from './layout'

export default [
  // 品库编辑
  {
    path: '/miniProgramAdminManage',
    component: Layout,
    meta: { groupTitle: '品库后台', title: '小程序开发', icon: 'miniprogram_admin_manage', roles: ['admin'] },
    children: [
      {
        path: '',
        name: 'adminManage',
        component: () => import(/* webpackChunkName: "noticeManage" */ '@v/miniProgramAdminManage/adminManage'),
        meta: { title: '授权方管理' },
      },
      {
        path: 'codeTemplate',
        name: 'codeTemplate',
        component: () => import(/* webpackChunkName: "noticeManage" */ '@v/miniProgramAdminManage/codeTemplate'),
        meta: { title: '代码管理'},
      },
    ],
  },
]
